var UserSettingsConfiguration = /** @class */ (function () {
    function UserSettingsConfiguration(obj) {
        this.name = '';
        this.label = '';
        this.type = 'check-list';
        this.query = null;
        Object.assign(this, obj);
        if (!this.type) {
            throw new Error('type is invalid');
        }
    }
    return UserSettingsConfiguration;
}());
export default UserSettingsConfiguration;
export var UserSettingsConfigurationConverter = function (value) {
    if (typeof value === 'string') {
        return new UserSettingsConfiguration(JSON.parse(value));
    }
    if (typeof value === 'object') {
        return new UserSettingsConfiguration(value);
    }
    return value;
};
export var UserSettingsConfigurationArrayConverter = function (value) {
    if (typeof value === 'string') {
        return JSON.parse(value).map(function (c) { return new UserSettingsConfiguration(c); });
    }
    if (typeof value === 'object') {
        return value.map(function (c) { return new UserSettingsConfiguration(c); });
    }
    return value;
};
